import { render, staticRenderFns } from "./DistributionItem.vue?vue&type=template&id=a7dacf54&scoped=true&"
import script from "./DistributionItem.vue?vue&type=script&lang=js&"
export * from "./DistributionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dacf54",
  null
  
)

export default component.exports